module.exports = __webpack_public_path__ + "media/images/parceiros_pagamentos/resized/hipercard-logo-0542d47a6dfac7d0d5abadbc9a20eb3b.svg";